import * as React from 'react';
export const IcTruckDelivery = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22 14v-1.54a3.059 3.059 0 00-.32-1.33l-1.24-2.47A3 3 0 0017.76 7H16V6a2 2 0 00-2-2H4a2 2 0 00-2 2v1h6a1 1 0 010 2H2v2h3a1 1 0 010 2H2v3a2 2 0 002 2h.18a3 3 0 005.64 0h4.36a3 3 0 005.64 0H20a2 2 0 002-2v-2zM7 18a1 1 0 110-2 1 1 0 010 2zm10 0a1 1 0 110-2 1 1 0 010 2zm-1-6V9h1.76a1 1 0 01.89.55L19.88 12H16z'
      fill='currentColor'
    />
  </svg>
);
